import ApiResourceManager from '../ApiResourceManager';

export default class FranchiseMobileAppManager extends ApiResourceManager {
  post = (data) =>
    this.request({
      method: 'POST',
      url: '/franchises/mobile-apps',
      data,
    });

  get = () =>
    this.request({
      method: 'GET',
      url: '/franchises/mobile-app',
    });

  put = (data) =>
    this.request({
      method: 'POST',
      url: '/franchises/mobile-app/update',
      data,
    });
}
